export default __webpack_public_path__ + "static/media/1236.27366724.png";